export enum OrderStatusTypes {
  PENDING = '1000',
  PAST = '1003'
}
